/** HTTP OK and API body reports success (child seat free booking). */
export function isChildSeatBookingSuccess(res) {
  const httpOk = res?.status >= 200 && res?.status < 300;
  const s = res?.data?.status;
  return httpOk && (s === 1 || s === "1");
}

/** User-facing error string from API body or HTTP status. */
export function childSeatBookingErrorMessage(data, httpStatus) {
  if (data && typeof data === "object") {
    const err = data.error ?? data.Error;
    if (err != null && String(err).trim() !== "") return String(err).trim();
    const msg = data.message ?? data.Message;
    if (msg != null && String(msg).trim() !== "") return String(msg).trim();
  }
  if (httpStatus && httpStatus !== 200) {
    return `Request failed (HTTP ${httpStatus}). Please try again.`;
  }
  return "We could not complete your booking. Please try again.";
}
